<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputUrl" });
import { InputText } from "../../../../inputs/index.js";
import { onDestroy, tick } from "svelte";
import { fetchUrlStatus } from "../../../url/services/api.js";
import { cleanUrlPath } from "./config/url-validation.js";
import Icon from "../../../../elements/icon/Icon.svelte";
import "tailwindcss/tailwind.css";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
const MINIMUM_VALID_URL_LENGTH = 4;
const TRIGGER_FETCH_DELAY_MS = 1e3;
let validationState;
let timeoutId;
const updateValidationState = async (state) => {
    if (timeoutId !== void 0) {
        clearTimeout(timeoutId);
    }
    validationState = state;
    await tick();
};
const urlValidation = async (url) => {
    const DATA = await fetchUrlStatus({ url });
    if ("status" in DATA) {
        void updateValidationState(DATA.status);
    }
};
const triggerValidationOnValueChange = (value2) => {
    const VALUE = typeof value2 === "string" ? value2.trim() : value2;
    if (VALUE === void 0 || VALUE === "") {
        void updateValidationState();
        return;
    }
    void updateValidationState("loading");
    timeoutId = setTimeout(() => {
        if (VALUE.length < MINIMUM_VALID_URL_LENGTH) {
            void updateValidationState("invalid");
            return;
        }
        const CLEANED_VALUE = cleanUrlPath(VALUE);
        if (CLEANED_VALUE === void 0) {
            void updateValidationState("invalid");
            return;
        }
        void urlValidation(CLEANED_VALUE);
    }, TRIGGER_FETCH_DELAY_MS);
};
$: triggerValidationOnValueChange(value);
onDestroy(() => {
    if (timeoutId !== void 0) {
        clearTimeout(timeoutId);
    }
});
</script>

<div class = 's8-input-url-wrapper'>

    {#if validationState === 'loading'}

        <div class = 's8-loading-icon'>
            <div class = 's8-icon-spinner'>
                <Icon key = 'loading' css = 'spinner' />
            </div>
        </div>

    {:else if validationState === 'valid'}
        <p class = { `s8-validation-message s8-${ validationState }` }>Valid Website</p>
    {:else if validationState === 'invalid'}
        <p class = { `s8-validation-message s8-${ validationState }` } >Please verify your input</p>
    {/if}

    <InputText
        bind:value = { value }
        { isDisabled }
        { isReadonly }
        { isRequired }
        maxLength = {600}
        hint = ''
        placeholder = 'Enter website URL'
        label = 'Website URL'
        name = 'organization.url'
        autocomplete = 'url'
    />

</div>

<style>
    div.s8-input-url-wrapper {
        position: relative;
    }

        div.s8-input-url-wrapper div.s8-loading-icon {
            position: absolute;
            top: 2.3rem;
            right: 0.5rem;
            transform: translateY(-90%);
        }

        div.s8-input-url-wrapper div.s8-loading-icon div.s8-icon-spinner {
                transform-origin: center;
                animation: spinner_AtaB 0.75s infinite linear;
            }

        @keyframes spinner_AtaB {
                    100% {
                        transform: rotate(360deg);
                    }
                }

        div.s8-input-url-wrapper .s8-validation-message {
            position: absolute;
            top: -0.05rem;
            right: 0;
            font-size: smaller;
            margin: 0;
        }

        div.s8-input-url-wrapper .s8-validation-message.s8-valid {
                color: #44835F;
            }

        div.s8-input-url-wrapper .s8-validation-message.s8-invalid {
                color: #EFC923;
            }</style>